<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
<path d="M3.11538 4C2.22288 4 1.5 4.716 1.5 5.6V6.4H22.5V5.6C22.5 4.716 21.7771 4 20.8846 4H3.11538ZM1.5 8.8V18.4C1.5 19.284 2.22288 20 3.11538 20H20.8846C21.7771 20 22.5 19.284 22.5 18.4V8.8H1.5ZM3.92308 10.4H10.3846V11.2H3.92308V10.4Z" fill="#000000"/>
</svg>
